import React, { Component, PropTypes } from 'react';
import controllable from 'react-controllables';
import EmptyState from '../../common/components/EmptyState';
import _ from 'underscore';
import PageTabs from './PageTabs';
import { Sticky, StickyContainer } from 'react-sticky';

const INVALID_ACTIVE = <EmptyState iconProps={{ name: 'exclamation-triangle' }}>Invalid section</EmptyState>;

class PageTabSections extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      section: PropTypes.node.isRequired
    })).isRequired,
    active: PropTypes.number.isRequired,
    onActiveChange: PropTypes.func.isRequired,
    tabContainerComponent: PropTypes.oneOfType([ PropTypes.func, PropTypes.string ])
  };

  static defaultProps = {
    active: 0,
    tabContainerComponent: 'div'
  };

  render() {
    const { options, active, onActiveChange, tabContainerComponent: TabContainerComponent, ...rest } = this.props;
    const sect = (active < 0 || active >= options.length) ? null : options[ active ];

    return (
      <div {...rest}>
        <TabContainerComponent
          style={{ backgroundColor: 'white', paddingTop: 10, borderBottom: '1px solid rgba(0,0,0,0.2)' }}
        >
          <div className="max-width">
            <PageTabs options={_.pluck(options, 'label')} active={active} onActiveChange={onActiveChange}/>
          </div>
        </TabContainerComponent>
        {
          sect === null ? INVALID_ACTIVE : <div key={options[ active ].key}>{options[ active ].section}</div>
        }
      </div>
    );
  }
}

export default controllable(PageTabSections, [ 'active' ]);


// WEBPACK FOOTER //
// ./src/js/components/layout/PageTabSections.jsx